import './index.css'
import {Component} from 'react'
import Cookies from 'js-cookie'
import {Redirect, Link} from 'react-router-dom'
import Loader from 'react-loader-spinner'

import {SiYoutubegaming} from 'react-icons/si'
import Header from '../Header'
import ThemeContext from '../ThemeContext'
import LeftPortion from '../LeftPortion'


const apiStatus = {
  initial: 'INITIAL',
  loading: 'LOADING',
  success: 'SUCCESS',
  failure: 'FAILURE',
}

const GameCard = ({gameDetails, theme}) => {
  const {id, title, thumbnailUrl, viewCount} = gameDetails

  return (
    <li className="game-card-list-item">
      <Link to={`/videos/${id}`} className="game-card-link">
        <img
          src={thumbnailUrl}
          className="game-card-thumbnail"
          alt="video thumbnail"
        />
        <div className="game-card-details">
          <p className={`game-card-title ${theme}`}>{title}</p>
          <p className="game-card-view-count">{viewCount} Watching Worldwide</p>
        </div>
      </Link>
    </li>
  )
}

class Gaming extends Component {
  state = {
    gamingVideos: [],
    fetchStatus: apiStatus.initial,
  }

  componentDidMount() {
    this.fetchGamingVideos()
  }

  fetchGamingVideos = async () => {
    this.setState({fetchStatus: apiStatus.loading})
    const apiUrl = `https://apis.ccbp.in/videos/gaming`
    const jwtToken = Cookies.get('jwt_token')
    const options = {
      headers: {Authorization: `Bearer ${jwtToken}`},
      method: 'GET',
    }

    try {
      const response = await fetch(apiUrl, options)
      if (response.ok) {
        const data = await response.json()
        const formattedData = data.videos.map(each => ({
          id: each.id,
          title: each.title,
          thumbnailUrl: each.thumbnail_url,
          viewCount: each.view_count,
        }))
        this.setState({
          gamingVideos: formattedData,
          fetchStatus: apiStatus.success,
        })
      } else {
        this.setState({fetchStatus: apiStatus.failure})
      }
    } catch (error) {
      this.setState({fetchStatus: apiStatus.failure})
    }
  }

  handleRetry = () => {
    this.fetchGamingVideos()
  }

  renderLoadingView = () => (
    <div className="view-container" data-testid="loader">
      <Loader type="ThreeDots" color="#4f46e5" height="50" width="50" />
    </div>
  )

  renderFailureView = theme => (
    <div className="view-container">
      <img
        className="failure-image"
        src={
          theme === 'light-theme'
            ? 'https://assets.ccbp.in/frontend/react-js/nxt-watch-failure-view-light-theme-img.png'
            : 'https://assets.ccbp.in/frontend/react-js/nxt-watch-failure-view-dark-theme-img.png'
        }
        alt="failure view"
      />
      <h1>Oops! Something Went Wrong</h1>
      <p>
        We are having some trouble completing your request. Please try again.
      </p>
      <button className="retry-button" type="button" onClick={this.handleRetry}>
        Retry
      </button>
    </div>
  )

  renderSuccessView = theme => {
    const {gamingVideos} = this.state
    return (
      <ul className="gaming-videos-grid-container">
        {gamingVideos.map(each => (
          <GameCard key={each.id} gameDetails={each} theme={theme} />
        ))}
      </ul>
    )
  }

  renderApiStatusView = theme => {
    const {fetchStatus} = this.state
    switch (fetchStatus) {
      case apiStatus.loading:
        return this.renderLoadingView()
      case apiStatus.success:
        return this.renderSuccessView(theme)
      case apiStatus.failure:
        return this.renderFailureView(theme)
      default:
        return null
    }
  }

  render() {
    if (Cookies.get('jwt_token') === undefined) {
      return <Redirect to="/login" />
    }

    return (
      <ThemeContext.Consumer>
        {value => {
          const {activeThemeIsLight} = value
          const theme = activeThemeIsLight ? 'light-theme' : 'dark-theme'

          return (
            <>
              <Header />
              <div className="page-container" data-testid="gaming">
                <LeftPortion />
                <div className={`content-container ${theme}`}>
                  <div className="page-header" data-testid="banner">
                    <div className="page-icon-container">
                      <SiYoutubegaming size={24} color="#ff0000" />
                    </div>
                    <h1>Gaming</h1>
                  </div>
                  <div className="content-body">
                    {this.renderApiStatusView(theme)}
                  </div>
                </div>
              </div>
            </>
          )
        }}
      </ThemeContext.Consumer>
    )
  }
}

export default Gaming
